import { fetcher } from '../utils'
import { ComponentInfoLoadChatsVO } from '@repo/types'

export default async (input: ComponentInfoLoadChatsVO): Promise<number> =>
  await fetcher(`/api/componentInfo/unreads`, 'POST', input)
